import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import AddUserForm from './AddUserForm';
import UserTable from './UserTable';
import EditRoleModal from './EditRoleModal';
import { FaArrowLeft } from 'react-icons/fa';

const Section = styled.div`
  margin-top: 20px;
`;

const AddUserButton = styled.button`
  background-color: #28a745;
  color: white;
  padding: 12px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  margin-bottom: 20px;

  &:hover {
    background-color: #218838;
  }
`;

const BackButton = styled.button`
  background: none;
  border: none;
  color: black;
  font-size: 14px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
`;

const DialogOverlay = styled.div`
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
`;

const DialogBox = styled.div`
  background: white;
  padding: 30px 40px;
  border-radius: 12px;
  text-align: center;
  width: 90%;
  max-width: 400px;
`;

const DialogButton = styled.button`
  padding: 10px 18px;
  margin: 12px;
  font-size: 16px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  background-color: ${({ confirm }) => (confirm ? '#dc3545' : '#ccc')};
  color: white;

  &:hover {
    opacity: 0.9;
  }
`;

//new
const TabButton = styled.button`
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  cursor: pointer;
  background-color: ${({ active }) => (active ? '#007bff' : '#e0e0e0')};
  color: ${({ active }) => (active ? 'white' : 'black')};

  &:hover {
    background-color: ${({ active }) => (active ? '#0056b3' : '#d0d0d0')};
  }
`;

const UserManagement = ({ onBack, user }) => {
    const [users, setUsers] = useState([]);
    const [showForm, setShowForm] = useState(false);
    const [editingRoleUser, setEditingRoleUser] = useState(null);
    const [showDialog, setShowDialog] = useState(false);
    const [selectedUserToDelete, setSelectedUserToDelete] = useState(null);
    const [activeTab, setActiveTab] = useState('active'); // 'active' or 'pending' new

    useEffect(() => {
        fetchUsers();
    }, []);


    const fetchUsers = async () => {
        try {

            const res = await fetch('/api/get_all_users', {
                method: 'GET',
                credentials: 'include',
            });
            const data = await res.json();
            console.log("Fetched users:", data);
            if (res.ok) {
                const allUsers = [
                    ...(Array.isArray(data.active_users) ? data.active_users : []),
                    ...(Array.isArray(data.pending_users) ? data.pending_users : [])
                ];
                setUsers(allUsers);
            } else {
                setUsers([]);
            }
        } catch (err) {
            console.error('Network error:', err);
        }
    };

    const handleAddUserClick = () => {
        setShowForm(true);
    };

    const handleAddUser = async (newUser) => {
        try {
            const res = await fetch('/api/add_user', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(newUser),
            });

            const data = await res.json();
            if (res.ok) {
                await fetchUsers();
                setShowForm(false);
            } else {
                console.error('Error adding user:', data.error);
            }
        } catch (err) {
            console.error('Add user failed:', err);
        }
    };

    const handleEditUser = (user) => {
        setEditingRoleUser(user);
    };

    const handleDeleteUser = (email) => {
        setSelectedUserToDelete(email);
        setShowDialog(true);
    };

    const confirmDelete = async () => {
        try {
            const res = await fetch('/api/delete_user', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email: selectedUserToDelete }),
            });

            const data = await res.json();
            console.log("Delete response:", data);
            if (res.ok) {
                setUsers((prev) => prev.filter((u) => u.email !== selectedUserToDelete));
                setShowDialog(false);
                setSelectedUserToDelete(null);
            } else {
                console.error('Delete failed:', data.error);
            }
        } catch (err) {
            console.error('Network delete error:', err);
        }
    };



    const filteredUsers = (users || []).filter(user =>
        activeTab === 'active' ? user.status === 'active' : user.status === 'pending'
    );

    if (user?.role !== 'Admin') {
        return (
            <Section>
                <h2>Access Denied</h2>
                <p>You do not have permission to manage users.</p>
                {onBack && (
                    <BackButton onClick={onBack}>
                        <FaArrowLeft size={14} />
                        Back to Settings
                    </BackButton>
                )}
            </Section>
        );
    }

    return (
        <Section>
            {onBack && (
                <BackButton onClick={onBack}>
                    <FaArrowLeft size={14} />
                    Back to Settings
                </BackButton>
            )}
            <h2>User Management</h2>

            {!showForm && (
                <AddUserButton onClick={handleAddUserClick}>Add User</AddUserButton>
            )}

            {showForm && (
                <AddUserForm
                    onAddUser={handleAddUser}
                // Removed editingUser prop since unused
                />
            )}

            {/* new*/}
            <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
                <TabButton
                    active={activeTab === 'active'}
                    onClick={() => setActiveTab('active')}
                >
                    Active Users
                </TabButton>
                <TabButton
                    active={activeTab === 'pending'}
                    onClick={() => setActiveTab('pending')}
                >
                    Pending Users
                </TabButton>
            </div>

            <UserTable

                users={filteredUsers} //new
                onEditUser={handleEditUser}
                onDeleteUser={handleDeleteUser}
                onRoleUpdated={fetchUsers}
            />

            {showDialog && (
                <DialogOverlay>
                    <DialogBox>
                        <p>Are you sure you want to delete this user?</p>
                        <DialogButton onClick={() => setShowDialog(false)}>Cancel</DialogButton>
                        <DialogButton confirm onClick={confirmDelete}>Delete</DialogButton>
                    </DialogBox>
                </DialogOverlay>
            )}

            {editingRoleUser && (
                <EditRoleModal
                    email={editingRoleUser.email}
                    currentRole={editingRoleUser.role}
                    onClose={() => setEditingRoleUser(null)}
                    onRoleUpdated={fetchUsers}
                />
            )}
        </Section>
    );
};

export default UserManagement;
